import { colors } from '../../colors';
var socialIcon = {
  fillColor: colors.white,
  fillHoverColor: colors.white,
  iconColor: colors.dustyTeal,
  iconHoverColor: colors.stoneTeal,
  iconBorderColor: 'transparent',
  iconBorderHoverColor: 'transparent'
};
export default socialIcon;